var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_19235)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6484 21.2788H17.5484V26.6063C17.5484 26.6915 17.5146 26.7731 17.4544 26.8333C17.3942 26.8935 17.3126 26.9273 17.2275 26.9273H13.9694C13.8842 26.9273 13.8026 26.8935 13.7424 26.8333C13.6822 26.7731 13.6484 26.6915 13.6484 26.6063V21.2788Z",
    fill: "url(#paint0_linear_2766_19235)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9653 18.8486H17.2316V23.3007C17.2316 23.4088 17.1886 23.5124 17.1122 23.5888C17.0358 23.6652 16.9322 23.7082 16.8241 23.7082H14.3728C14.2647 23.7082 14.1611 23.6652 14.0847 23.5888C14.0083 23.5124 13.9653 23.4088 13.9653 23.3007V18.8486Z",
    fill: "#791186"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1781 2.0217L11.9801 2.35799C9.84561 2.58246 8.29715 4.49532 8.52163 6.62939L9.55102 16.4183C9.77549 18.5528 11.6884 20.1012 13.8223 19.8767L17.0199 19.5405C19.1544 19.316 20.7028 17.4031 20.4784 15.2691L19.4491 5.48018C19.225 3.34569 17.3126 1.7968 15.1781 2.0217Z",
    fill: "#FADCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9049 4.47816C15.1033 4.52591 13.3083 4.71468 11.5362 5.04271C11.2899 5.08861 11.1157 5.36531 11.1466 5.65685C11.1774 5.94839 11.4016 6.14833 11.6483 6.10643C13.4238 5.80237 15.2171 5.61379 17.017 5.54187C17.2672 5.53135 17.4449 5.28919 17.4143 4.99775C17.3833 4.70621 17.1556 4.47173 16.9049 4.47816Z",
    fill: "url(#paint1_linear_2766_19235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1038 6.36376C15.3052 6.4544 13.5129 6.64286 11.7348 6.92831C11.4879 6.96832 11.3136 7.23922 11.3437 7.53076C11.3744 7.8223 11.5992 8.02793 11.8467 7.99203C13.6243 7.73091 15.4222 7.54182 17.2154 7.42748C17.4648 7.41116 17.6419 7.1631 17.6114 6.87166C17.581 6.58002 17.3538 6.35144 17.1038 6.36376Z",
    fill: "url(#paint2_linear_2766_19235)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3024 8.24958C15.5113 8.38255 13.7133 8.57165 11.9337 8.81413C11.6861 8.84814 11.5107 9.11335 11.5413 9.40489C11.5721 9.69643 11.7976 9.90785 12.0455 9.87774C13.8277 9.65937 15.6253 9.47028 17.4142 9.31319C17.6631 9.29108 17.8396 9.03723 17.8091 8.7458C17.7785 8.45426 17.5517 8.23136 17.3024 8.24958Z",
    fill: "url(#paint3_linear_2766_19235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 10.1352C15.7136 10.3109 13.9157 10.4999 12.1316 10.6998C11.8835 10.7279 11.7074 10.9873 11.7381 11.2788C11.7687 11.5703 11.9949 11.7875 12.2435 11.7632C14.03 11.5872 15.8281 11.3987 17.6122 11.1986C17.8604 11.1705 18.0364 10.9112 18.0057 10.6195C17.9751 10.3278 17.7491 10.1106 17.5004 10.1352Z",
    fill: "url(#paint4_linear_2766_19235)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6985 12.0204C15.9163 12.2388 14.1188 12.4279 12.3298 12.585C12.081 12.6072 11.9044 12.8608 11.9351 13.1524C11.9658 13.4438 12.1924 13.6668 12.4417 13.6486C14.2328 13.5156 16.0308 13.3265 17.8104 13.084C18.058 13.0499 18.2333 12.7848 18.2028 12.4933C18.172 12.2017 17.9466 11.9903 17.6985 12.0204Z",
    fill: "url(#paint5_linear_2766_19235)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8966 13.906C16.1189 14.167 14.321 14.3561 12.5278 14.4705C12.2784 14.4867 12.1012 14.7347 12.1319 15.0262C12.1625 15.3178 12.3899 15.5464 12.6398 15.5341C14.4383 15.4435 16.2305 15.2551 18.0085 14.9696C18.2554 14.9296 18.4296 14.6587 18.3995 14.3671C18.3689 14.0756 18.1441 13.8699 17.8966 13.906Z",
    fill: "url(#paint6_linear_2766_19235)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0956 15.7917C16.3201 16.0958 14.5267 16.2844 12.7267 16.3562C12.4768 16.3667 12.299 16.6089 12.3296 16.9003C12.3602 17.1919 12.5882 17.4262 12.8387 17.4199C14.6402 17.3722 16.4353 17.1834 18.2074 16.8554C18.4537 16.8095 18.6278 16.5328 18.5969 16.2412C18.5666 15.9497 18.3425 15.7499 18.0956 15.7917Z",
    fill: "url(#paint7_linear_2766_19235)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M16.5517 9.90065C15.5168 7.7073 12.5603 8.22658 11.6172 6.2655C11.2366 5.47395 11.1776 4.26504 12.1802 2.33691L11.9801 2.35797C9.84561 2.58244 8.29715 4.4953 8.52163 6.62937L9.55102 16.4183C9.77549 18.5527 11.6884 20.1012 13.8224 19.8767L17.0197 19.5404C17.4541 19.4951 17.8777 19.3767 18.2726 19.1903C16.8229 17.6723 16.3467 16.3141 16.2186 15.2584C15.9287 12.8687 17.3742 11.6441 16.5517 9.90065Z",
    fill: "url(#paint8_linear_2766_19235)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3244 22.7643C16.7252 22.3635 16.7252 21.7137 16.3244 21.3128C15.9236 20.912 15.2738 20.912 14.8729 21.3128C14.4721 21.7137 14.4721 22.3635 14.8729 22.7643C15.2738 23.1651 15.9236 23.1651 16.3244 22.7643Z",
    fill: "url(#paint9_linear_2766_19235)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5528 18.4458C13.559 18.4458 12.7313 17.5088 12.6268 16.2664L11.8056 6.4775C11.7513 5.83104 11.9012 5.19679 12.2272 4.69162C12.5533 4.18645 13.0169 3.87038 13.5328 3.80289L16.0823 3.46681C16.1508 3.45771 16.2199 3.45313 16.289 3.45312C17.2828 3.45313 18.1105 4.39018 18.215 5.63257L19.0363 15.4215C19.1481 16.756 18.3735 17.9558 17.3096 18.0958L14.7595 18.4325C14.691 18.4415 14.6221 18.4461 14.553 18.4461L14.5528 18.4458Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2766_19235",
    x1: 18.1176,
    y1: 20.1926,
    x2: 10.0292,
    y2: 32.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2766_19235",
    x1: 14.8709,
    y1: 4.25951,
    x2: 10.1807,
    y2: 15.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2766_19235",
    x1: 15.9916,
    y1: 4.72015,
    x2: 11.3015,
    y2: 16.1276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2766_19235",
    x1: 17.1121,
    y1: 5.18099,
    x2: 12.4221,
    y2: 16.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2766_19235",
    x1: 18.2319,
    y1: 5.64124,
    x2: 13.5419,
    y2: 17.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2766_19235",
    x1: 19.3521,
    y1: 6.10192,
    x2: 14.6621,
    y2: 17.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2766_19235",
    x1: 20.472,
    y1: 6.56249,
    x2: 15.782,
    y2: 17.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2766_19235",
    x1: 21.5929,
    y1: 7.0234,
    x2: 16.9028,
    y2: 18.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2766_19235",
    x1: 8.89821,
    y1: 11.4821,
    x2: 17.1987,
    y2: 10.6437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2766_19235",
    x1: 17.5199,
    y1: 19.2577,
    x2: 15.1675,
    y2: 22.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_19235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoices);
export default __webpack_public_path__ + "static/media/Voices.995452939a5d26c80b46a49e2b07349b.svg";
export { ForwardRef as ReactComponent };